import {
  rendererRegistryEntries,
} from '@great-expectations/jsonforms-antd-renderers'
import { isDateControl, isEnumControl, isIntegerControl, isNumberControl, isStringControl, JsonFormsRendererRegistryEntry, or, rankWith } from '@jsonforms/core';
import HorizontalLayout from './renderers/HorizontalLayout';
import SelectControl from './renderers/SelectControl';
import TextControl from './renderers/TextControl';
import DateControl from './renderers/DateControl';
import NumberControl from './renderers/NumberControl';
import LayoutHeader from './renderers/LayoutHeader';
import DateTimeControl from './renderers/DateTimeControl';

export * from './form-types'

export const customRenderers: JsonFormsRendererRegistryEntry[] = [
    ...rendererRegistryEntries,
    {
      tester: rankWith(3, uischema => uischema.type === "HorizontalLayout"),
      renderer: HorizontalLayout,
    },
    {
      tester: rankWith(3, uischema => uischema.type === "LayoutHeader"),
      renderer: LayoutHeader,
    },
    {
      tester: rankWith(10, isEnumControl),
      renderer: SelectControl,
    },
    {
      tester: rankWith(10, isStringControl),
      renderer: TextControl,
    },
    {
      tester: rankWith(11, isDateControl),
      renderer: DateControl,
    },
    {
      tester: rankWith(3, uischema => uischema.type === "DateTime"),
      renderer: DateTimeControl,
    },
    {
      tester: rankWith(10, or(isNumberControl, isIntegerControl)),
      renderer: NumberControl,
    },
  ];
